var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('BaseLoading',{attrs:{"is-full-page":""}}):_c('BundleSetForm',{attrs:{"default-data":_vm.defaultData}})}
var staticRenderFns = []

export { render, staticRenderFns }